import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	suggestDescriptionLabel: {
		id: 'custom-sites-extensions.link-cards.description.button.suggest-description.label',
		defaultMessage: 'Suggest Description',
		description: 'Text in the button to prompt user to generate a description for link using AI',
	},
});
